<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/purgematch")
          i.fa.fa-trash
          span.ml-1 {{ $t("ui.purge_match") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.match_id") }}
                    DebounceInput(required type="text" v-model="purgeMatchSearch" :placeholder="$t('message.search_by_league_name')")
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getPurgeMatchList(true)"
                    variant="success"
                    size="sm"
                    ).mr-2
        div.card-body
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th(width=100)
                        span {{ $t('ui.id') }}
                      th(width=80)
                        span {{ $tc('ui.sports', 1) }}
                      th
                        span {{ $tc("ui.leagues", 1) }}
                      th
                        span {{ $t("ui.home") }}
                      th
                        span {{ $t("ui.away") }}
                      th(width=120)
                        span {{ $t("ui.mapped_time") }}
                      th(width=60)
                        span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                      th(width=80)
                        span {{ $t("ui.short.match_date") }}
                      th(width=80)
                        span {{ $t("ui.short.match_time") }}
                      th(width=70)
                        span {{ $t("ui.sbo") }}
                      th(width=70)
                        span {{ $t("ui.ibc") }}
                      th(width=70)
                        span {{ $t("ui.linked") }}
                      th.text-center(width=80)
                        span {{ $t("ui.action") }}
                  tbody.clusterize-content
                    tr(v-if="purgeMatchList.length == 0")
                      td(colspan="13").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in purgeMatchList")
                      td
                        span {{ item.match_id }}
                      td
                        span {{ item.sport_type }}
                      td
                        span(:title="item.league_name") {{ item.league_name }}
                      td
                        span(:title="item.home_team") {{ item.home_team }}
                      td
                        span(:title="item.away_team") {{ item.away_team }}
                      td
                        span {{ $moment(item.created_on).format("YYYY-MM-DD HH:mm:ss") }}
                      td.text-uppercase
                        span {{ item.market_type }}
                      td
                        span {{ getDate(item.match_date) }}
                      td
                        span {{ item.match_time }}
                      td
                        span {{ item.sbo_map }}
                      td
                        span {{ item.ibc_map }}
                      td
                        span {{ item.link_id }}
                      td.actions
                        span
                          a.fa.fa-trash.text-primary(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    purgeMatchSearch: '',
    purgeMatchList: [],
    purgeMatchTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
  },
  mounted: function() {
  },
  methods: {
    getDate(dateTime) {
      let convertDateFormat = this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    getPurgeMatchList: function() {
      let url = config.getPurgeMatchListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.purgematch,
        match_id: this.purgeMatchSearch.trim()
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.purgeMatchList = response.data.tbl_purge_match_list;
                if (this.purgeMatchList.length == 0)
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.thisMatchNotExists"), "error");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onDelete(item) {
      this.purgeMatch(item);
    },
    purgeMatch: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.purge_match"),
          text: this.$t("message.purge_match_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPurgeMatch(item);
          }
        });
    },
    confirmPurgeMatch(item) {
      let url = config.purgeMatchUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.purgematch,
        match_id: item.match_id,
        link_id: item.link_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$snotify.success(this.$t("message.success"));
                this.purgeMatchList = [];
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>